import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import classes from '../../framework/framework/tools/classes';
import Emitter from '../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../services/eventEmmiter/EventTypes';
import { BasketService } from '../../services/basket/BasketService';
import { IBasketItem } from '../../services/productService/models/IBasketItem';
import { IBasketModel } from '../../services/productService/models/IBasketModel';
// import { Helmet } from 'react-helmet';
import * as style from './style.css';
import BasketItem from './basketItem/BasketItem';
import ActionButton from '../../components/actionButton/ActionButton';
import DeliveryPage from './DeliveryPage';
import React = require('react');

interface IProps {
    controller: string;
    appCtx: ApplicationContext;
}
interface IState {
    basket: IBasketModel;
    step: number;
}

export default class BasketPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            basket: null,
            step: 0
        };
    }

    basketService: BasketService;

    componentDidMount() {
        this.basketService = BasketService.Instance();
        this.updateBasket();
        Emitter.on(EventTypes.UserData, () => this.updateBasket());
    }

    updateBasket() {
        this.basketService.calculateBasket((basket: IBasketModel) => this.setState({ basket: basket }));
    }

    render() {
        return (
            <div className={style.basketWrapper}>
                {/* <Helmet>
                    <title>{'apcprodent.pl - koszyk zakupowy, najlepsze produkty z dostawą do gospodarstwa'}</title>
                    <meta name="description" content={'Zrób zakupy bez rejestracji lub zaloguj się i zyskaj dodatkowe bonusy.'} />
                </Helmet> */}
                {this.state.basket &&
                    this.renderStep(this.state.step)
                }

            </div>
        );
    }

    renderStep(step: number): JSX.Element {
        if (this.state.basket.items.length === 0) {
            return <>
                <div className={style.emptyBasket}>
                    Twój koszyk jest pusty. Zapraszamy do katalogu.
                    <div style={{ width: 'min(280px, 90%)', padding: '10px', height: '4rem', marginTop: '3rem', display: 'flex' }}>
                        <ActionButton label={'Katalog'} onClick={() => { window.location.href = `${this.props.appCtx.buildUrl('/katalog')}`; }} >
                        </ActionButton>
                    </div>
                </div>
            </>;
        }

        return this.steps()[step];
    }

    steps(): JSX.Element[] {
        const steps = [];
        steps.push(<>

            <div key={'basket'} className={classes('')}>
                <div key={1} >
                    {<div className={style.basketContent}>
                        {this.state.basket.items.map(i => this.renderItem(i))}
                        <div className={style.summary}>
                            {this.state.basket.summary.total.toFixed(2)}
                        </div>

                    </div>}
                </div>
            </div>
            <div style={{ width: '280px', padding: '10px', height: '4rem', display: 'flex' }}>
                <ActionButton label={'Dostawa'} onClick={() => this.onStepClick(1)} >
                </ActionButton>
            </div>

        </>);
        steps.push(<>
            <>
                <DeliveryPage appCtx={this.props.appCtx} >

                    <div style={{ width: '280px', padding: '10px', marginTop: '2rem', display: 'flex' }}>
                        <ActionButton label={'Koszyk'} onClick={() => this.onStepClick(-1)} >
                            <span className="material-icons">
                                arrow_back_ios
                            </span>
                        </ActionButton>
                    </div>
                </DeliveryPage>
            </>
        </>);
        return steps;
    }

    renderItem(i: IBasketItem): any {
        return <BasketItem
            key={i.slug}
            itemUri={this.props.appCtx.buildUrl('produkty/' + i.slug)}
            item={i}
            onUpdateItem={(e) => this.updateQty(e.quantity, e.productId)}
            onRemoveItem={(e) => this.removeItem(e.productId)}

        />;
    }

    onStepClick(step: number): void {
        this.setState(prev => ({ step: prev.step + step }));
    }

    removeItem(productId: number) {
        this.basketService.removeItem(productId, (basket: IBasketModel) => {
            this.setState({ basket: basket });
        });
    }

    updateQty(qty: number, prodId: number) {
        if (qty <= 0) { return; }
        this.basketService.updateItem(prodId, qty, () => {
            this.updateBasket();
        });
    }
}
